/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "/Users/pajk01/workspace/n34220_autoconfig_STATIC/vue-scrm_temp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import { GETTER_MINI_PRODUCT_INFO } from '@/store/mutation_types';
import defalutImg from '@/resources/images/default.png';
export default {
  data: function data() {
    return {
      defalutImg: defalutImg
    };
  },
  created: function created() {},
  mounted: function mounted() {},
  computed: _objectSpread({}, mapGetters({
    productInfo: 'GETTER_MINI_PRODUCT_INFO'
  })),
  methods: {
    goBuy: function goBuy(link) {
      window.location.href = link;
    }
  }
};